export default __webpack_public_path__ + "static/media/clock.f1fa15a5.svg";